import { useEffect, useState } from 'react'

/**
 * Keeps a component mounted for `delay` ms after `isOpen` becomes false,
 * allowing exit animations to complete before the subtree is unmounted.
 *
 * @returns `mounted` — whether the component should exist in the tree.
 *          `open` — mirrors `isOpen`; goes false immediately so exit animation triggers.
 */
export function useDeferredUnmount(
  isOpen: boolean,
  delay = 300
): { mounted: boolean; open: boolean } {
  const [mounted, setMounted] = useState(isOpen)

  useEffect(() => {
    if (isOpen) {
      setMounted(true)
    } else {
      const timer = setTimeout(() => setMounted(false), delay)
      return () => clearTimeout(timer)
    }
  }, [isOpen, delay])

  return { mounted, open: isOpen }
}
